import { render, staticRenderFns } from "./x-input.vue?vue&type=template&id=e59f3940&"
import script from "./x-input.vue?vue&type=script&lang=js&"
export * from "./x-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports